// This file is autogenerated from /frontend/sail-next/packages/docs/src/markdoc/demo/checkbox/index.tsx with go/sail-next-tailor-docs-publisher

import * as React from 'react';
import {Indeterminate} from './Indeterminate.story';
import {Primary} from './Primary.story';
import {Invalid} from './Invalid.story';
import {Disabled} from './Disabled.story';
import {Uncontrolled} from './Uncontrolled.story';

const basic = {
  rendered: <Primary />,
  source: `<Checkbox
  label="This is a Checkbox."
  onChange={(e) => {
    console.log(e.target.checked);
  }}
/>`,
};
const uncontrolled = {
  rendered: <Uncontrolled />,
  source: `<Checkbox
  onChange={(e) => {
    console.log(e.target.checked);
  }}
  defaultChecked
  label="This Checkbox is uncontrolled."
/>`,
};
const disabled = {
  rendered: <Disabled />,
  source: `<Checkbox
  label="This Checkbox is disabled."
  defaultChecked
  disabled
/>
<Checkbox
  disabled
  invalid
  label="This invalid Checkbox is disabled."
/>`,
};
const invalid = {
  rendered: <Invalid />,
  source: `<Checkbox label="This Checkbox is in an invalid state." invalid />`,
};
const indeterminate = {
  rendered: <Indeterminate />,
  source: `const [checked1, setChecked1] = React.useState(false);
const [checked2, setChecked2] = React.useState(true);

return (
  <Box
    css={{
      layout: 'column',
    }}
  >
    <Checkbox
      label="This Checkbox is aggregating the state of the Checkboxes below it."
      readOnly
      key={checked1 && checked2}
      defaultChecked={checked1 && checked2}
      indeterminate={checked1 !== checked2}
    />
    <Checkbox
      label="Checkbox 1"
      onChange={(e) => {
        setChecked1(e.target.checked);
      }}
    />
    <Checkbox
      label="Checkbox 2"
      defaultChecked
      onChange={(e) => {
        setChecked2(e.target.checked);
      }}
    />
  </Box>
);`,
};
export const CheckboxExamples = {
  basic,
  uncontrolled,
  disabled,
  invalid,
  indeterminate,
};
